export enum ViolationTypeEnum {
  POST = 'POST',
  COMMENT = 'COMMENT',
}
